/**
 * A global namespace for `mouseenter` event.
 */
const mouseenterEvent = "mouseenter";
export default mouseenterEvent;
